import apiEnrollment from '@/api/enrollment'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getEnrollmentStart: '[enrollment] Get enrollment start',
  getEnrollmentSuccess: '[enrollment] Get enrollment success',
  getEnrollmentFailure: '[enrollment] Get enrollment failure',
}

export const actionTypes = {
  getEnrollment: '[enrollment] Get trainer',
}

const mutations = {
  [mutationTypes.getEnrollmentStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getEnrollmentSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }

    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getEnrollmentFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getEnrollment](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)
    context.commit(mutationTypes.getEnrollmentStart)
    return new Promise((resolve) => {
      apiEnrollment
        .getEnrollmentList(params)
        .then((response) => {
          context.commit(mutationTypes.getEnrollmentSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getEnrollmentFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
